import handleResponse, { mapLicencesResponse } from './request/handleResponse'
import { IData } from './request/response'

export default function(api: GlobalFetch) {
  return async function(user, subs) {
    const integrations = await api.fetch(`/api/v2/license/index/`)
    const licences = await api.fetch(`/api/v2/license/list/`)

    if (subs) {
      const json2: IData = await integrations.json()
      const json: IData = await licences.json()
      const data = mapLicencesResponse(json2, json, subs, user)
      return data
    }

    return await handleResponse(integrations, licences, user)
  }
}
